import { FC, useEffect, useState, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { BetType } from "../../types/common";
import { Button, ButtonType } from "../../components/Button";
import query from "../../query";
import {
  DEFAULT_PROVIDER,
  isSabaComboDisabled,
} from "../../utils/providerQuery";

export type BetTypeSelectorProps = {
  isParlayDisabled?: boolean;
  isComboDisabled?: boolean;
  sport?: string;
};

const BetTypeSelector: FC<BetTypeSelectorProps> = ({
  isParlayDisabled = false,
  isComboDisabled = false,
  sport = "football",
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [betType, setBetType] = useState<BetType>("normal");
  const providerQuery = query.provider();
  const pvd = useQuery(providerQuery.key, providerQuery.queryFn, {
    refetchOnMount: false,
    keepPreviousData: true,
  });
  const selectedProvider = pvd.data ?? DEFAULT_PROVIDER;
  const isSabaComboBlocked = isSabaComboDisabled(selectedProvider, sport);
  const shouldDisableCombo = isComboDisabled || isSabaComboBlocked;

  useEffect(() => {
    switch (pathname) {
      case "/football-parlay":
        setBetType("step");
        break;
      case "/combo-step":
        setBetType("comboStep");
        break;
      default:
        break;
    }
  }, [pathname]);

  const handleClickSingle = useCallback(() => {
    navigate("/football/live-today");
  }, [navigate]);

  const handleClickParlay = useCallback(() => {
    navigate("/football-parlay");
  }, [navigate]);

  const handleClickCombo = useCallback(() => {
    navigate("/combo-step");
  }, [navigate]);

  return (
    <>
      {!isParlayDisabled && (
        <>
          {betType !== "normal" && (
            <Button
              buttonType={ButtonType.SECONDARY}
              className="mr-3 text-sm px-5"
              onClick={handleClickSingle}>
              Single
            </Button>
          )}
          {betType !== "step" && (
            <Button
              buttonType={ButtonType.SECONDARY}
              className="mr-3 text-sm px-5"
              onClick={handleClickParlay}>
              Parlay
            </Button>
          )}
        </>
      )}

      {!shouldDisableCombo && betType !== "comboStep" && (
        <Button
          buttonType={ButtonType.SECONDARY}
          className="mr-3 text-sm px-5"
          onClick={handleClickCombo}>
          Combo
        </Button>
      )}
    </>
  );
};

export default BetTypeSelector;
